import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import Cookies from "cookies-js";
import * as tools from "../../helpers/Tools";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as msgs from "../../constants/textConstants";
import { isValidDate } from "../../helpers/dateTime";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { logReactError } from "../../api/loggingApi";
import { authContext } from "../../adalConfig";

class EnsureLoggedIn extends React.Component {

    constructor(props) {
        super(props);

        this.buildUniqueID = this.buildUniqueID.bind(this);
        this.startCountDownTimer = this.startCountDownTimer.bind(this);
        this.clearCountDownTimer = this.clearCountDownTimer.bind(this);
        this.countdownTimerTick = this.countdownTimerTick.bind(this);
        this.setupClickHandlers = this.setupClickHandlers.bind(this);
        this.clearInactivityTimer = this.clearInactivityTimer.bind(this);
        this.setInactivityTimer = this.setInactivityTimer.bind(this);
        this.timedOut = this.timedOut.bind(this);
        this.resetInactivityTimer = this.resetInactivityTimer.bind(this);
        this.newClickHandler = this.newClickHandler.bind(this);
        this.newKeypressHandler = this.newKeypressHandler.bind(this);
        this.clearClickHandlers = this.clearClickHandlers.bind(this);
        this.callRefreshToken = this.callRefreshToken.bind(this);
        this.setTimer = this.setTimer.bind(this);
        this.cleanupTimer = this.cleanupTimer.bind(this);
        this.resetCountersFromProperties = this.resetCountersFromProperties.bind(this);
    }

    //componentWillMount() {
    //    console.log("Ensured logged in-componentWillMount");
    //}

    componentDidMount() {
        const { isLoggedIn, currentURL, setRedirectUrl, refreshToken } = this.props;
        var isLoggedIn2 = (authContext.getCachedUser() !== null);
        this.bHasWindow = (typeof window !== "undefined");
        //console.log(isLoggedIn);
        //console.log(currentURL);
        //console.log("This is the refresh token we received: " + this.props.RefreshToken);
        //debugger;
        const sPath = tools.getURLPath(this.props.attributePath).toLowerCase();

        if (!isLoggedIn && !isLoggedIn2 && sPath !== '/login') {
        }

        this.resetCountersFromProperties();
        this.resetInactivityTimer();

        this.setupClickHandlers();

        this.setTimer();

        if (this.uniqueID !== null) {
            //debugger;
        }
        else {
            this.uniqueID = this.buildUniqueID();
        }

    }

    //componentWillReceiveProps(nextProps, nextContext) {
    //console.log("WillReceivePropts-TEST");
    //}

    //componentWillUpdate(nextProps, nextState, nextContext) {
    //console.log("WillUpdate-TEST");
    //}



    componentDidUpdate(prevProps, prevState, snapshot) {
        // we're not resetting the inactivity timer, only the reset token timer
        const { token, isLoggedIn } = this.props;
        if (prevProps.token !== token) { // update the refresh timer any time the token changes
            this.setTimer();
        }
        if (!prevProps.isLoggedIn && isLoggedIn) { // here, we start the idle count down timer 
            this.setInactivityTimer();
        }
        if (!isLoggedIn && prevProps.isLoggedIn) {
            this.clearCountDownTimer(); // clear the countdown timer whenever we logout
            this.clearInactivityTimer();
        }

    }

    componentWillUnmount() {
        //alert("Will unmount!");
        console.log("Ensured logged in-componentWillUnmount");
        this.clearInactivityTimer();
        this.clearClickHandlers();
        this.cleanupTimer();
    }

    resetCountersFromProperties() {
        if (this.props.attributeIdleTimeoutSeconds) {
            this.idleTimeoutSeconds = this.props.attributeIdleTimeoutSeconds;
        }
        if (this.props.attributeIdleTimeoutCountdownSeconds) {
            this.idleTimeoutCountdownSeconds = this.props.attributeIdleTimeoutCountdownSeconds;
        }

    }



    bHasWindow = false;

    uniqueID = null;

    refreshTimer = null;
    timerToken = null;

    inactivityTimer = null;

    originalOnKeypress = null;
    originalOnClick = null;
    handlerSet = null;

    dialogIsOpen = false;
    idleTimeoutSeconds = 60;
    idleTimeoutCountdownSeconds = 60;

    countdownSecondsRemaining = 60;
    countdownTimer = null;

    buildUniqueID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    startCountDownTimer() {
        this.clearCountDownTimer();
        if (!this.props.isMobile) {
            this.countdownSecondsRemaining = this.idleTimeoutCountdownSeconds;
            this.countdownTimer = window.setInterval(this.countdownTimerTick, 1000);
        }
    }

    clearCountDownTimer() {
        if (this.countdownTimer !== null) {
            if (this.bHasWindow) {
                window.clearInterval(this.countdownTimer);
            }
            this.countdownTimer = null;
        }
    }

    countdownTimerTick() {
        this.countdownSecondsRemaining = this.countdownSecondsRemaining - 1;
        if (this.countdownSecondsRemaining < 1) {
            this.clearCountDownTimer();
            //debugger;
            this.props.logout(msgs.SystemInitiatedLogoutMessage);
            logUI("MBHWeb.Login.SessionExpired.Logout", new Date(), Tools.getURLPath());

            // Since this has a global life, even on the login page now, we must do this
            this.resetCountersFromProperties();
            this.resetInactivityTimer();
            this.cleanupTimer();  // componentDidUpdate will restart the timer when needed

        };
        this.forceUpdate();
    }



    setupClickHandlers() {
        //debugger;
        if (this.bHasWindow) {
            window.addEventListener("click", this.newClickHandler, false);
            window.addEventListener("keypress", this.newKeypressHandler, false);
        }
    }

    clearInactivityTimer() {
        if (this.inactivityTimer !== null) {
            if (this.bHasWindow) {
                window.clearTimeout(this.inactivityTimer);
            }
            this.inactivityTimer = null;
        }
    }

    setInactivityTimer() {
        if (!this.props.isMobile) {
            if (this.inactivityTimer === null) {
                if (this.bHasWindow) {
                    this.inactivityTimer = window.setTimeout(this.timedOut, this.idleTimeoutSeconds * 1000);
                }
            }
        }
    }

    timedOut() {
        const { isMobile } = this.props;
        if (window.lastJitsi &&
            Number.isInteger(window.lastJitsi) &&
            window.lastJitsi > 0 &&
            Date.now() < window.lastJitsi + (this.idleTimeoutSeconds * 1000)
        ) {
            this.resetInactivityTimer(); // We reset the timer in case we timed out while jitsi was up
            return;
        }
        if (!this.props.isMobile) {
            if (!this.props.isLoggedIn) {
                //debugger;
                //alert("Ok... you're not logged in so we'll just silently reload the timer here.");
                this.resetInactivityTimer();
            }
            else {
                // popup here
                this.dialogIsOpen = true;
                this.startCountDownTimer();
                //alert("Heh!! Do something! You're logged in!");
            }
        }
    }

    resetInactivityTimer() {
        //debugger;
        this.clearCountDownTimer();
        this.clearInactivityTimer();
        this.setInactivityTimer();
        if (this.dialogIsOpen) {
            this.dialogIsOpen = false;
            this.forceUpdate();
        }
    }

    newClickHandler() {
        this.resetInactivityTimer();
        if (this.originalOnClick !== null) {
            this.originalOnClick();
        }
    }

    newKeypressHandler() {
        this.resetInactivityTimer();
        if (this.originalOnKeypress !== null) {
            this.originalOnKeypress();
        }
    }

    clearClickHandlers() {
        if (this.bHasWindow) {
            window.removeEventListener("keypress", this.newKeypressHandler);
            window.removeEventListener("click", this.newClickHandler);
        }
    }

        
    
    componentDidCatch(error, errorInfo) {
        console.log("ErrTEST:" + error);
        let json = { error: error, componentStack: errorInfo };
        //logUI("MBHWeb.UI.EnsureLoggedIn.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(error), JSON.stringify(errorInfo));
    }

    callRefreshToken() {
        //debugger;
        if (this.props) {
            if (this.props.refreshToken && this.props.refresh_token) { 
                this.props.refreshToken(this.props.refresh_token);
                logUI("MBHWeb.Login.Call.RefreshToken", new Date(), Tools.getURLPath());
            }
        }
    }

    setTimer() {
        if (!this.props.isLoggedIn) {
            this.cleanupTimer();
        }
        else {
            if (this.props.token !== this.timerToken && this.timerToken !== null) {
                this.cleanupTimer();
            }
            if (!this.props.isMobile) {
                if (this.props.expiresDate) {
                    var dateThen = new Date(this.props.expiresDate);
                    var dateNow = new Date();
                    var elapsed = Math.floor((dateThen.getTime() - dateNow.getTime()) / 1000);
                    var remaining = elapsed - (5 * 60);
                    if (remaining < 1) {
                        this.callRefreshToken();
                    }
                    else {
                        //debugger;
                        if (this.props.token !== null && (this.timerToken === null || this.timerToken === undefined || this.timerToken !== this.props.token)) {
                            this.timerToken = this.props.token;
                            if (this.bHasWindow) {
                                this.refreshTimer = window.setTimeout(this.callRefreshToken, remaining * 1000);
                            }
                        }
                    }
                }
            }
        }
    }

    cleanupTimer() {
        if (this.refreshTimer !== null) {
            if (this.bHasWindow) {
                window.clearTimeout(this.refreshTimer);
            }
            this.refreshTimer = null;
            this.timerToken = null;
        }
    }


    render() {
        var isClientSide = this.bHasWindow; // typeof window !== 'undefined';
        //console.log("Now rendering EnsureLoggedIn... isClientSide: " + isClientSide);
        //debugger;
        //const sPath = tools.getURLPath(this.props.attributePath).toLowerCase();

        //console.log("EnsureLoggedIn.render()");
        //debugger;
        if (this.props.isLoggedIn) {
            //this.props.isLoggedIn = true;
            //refreshToken(this.props.RefreshToken);
            return (
                <div>
                    {this.props.children}
                    <Modal isOpen={this.dialogIsOpen} toggle={this.resetInactivityTimer} centered backdrop="static" className="ensureloggedin-modal">
                        <ModalBody>
                            <h2 className="modal-heading">Are you still there?</h2>
                            <p>You will be logged out in <span id="spanIdleTimeout">{this.countdownSecondsRemaining}</span> seconds due to inactivity.</p>
                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-primary" onClick={this.resetInactivityTimer}>STAY LOGGED IN</button>
                            <button className="btn btn-primary" onClick={() => this.props.logout(msgs.UserInitiatedLogoutMessage)}>LOG ME OUT</button>
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
        else {
            this.cleanupTimer();  // need to do this for cases where we get logged out after the timer is configured.  Timer will continue to fire and countdown and change the message
            this.clearCountDownTimer();
        }
        //else if (this.props.isLoggedIn) {
        //    //debugger;
        //    //console.log("Now rendering children...");
        //    return this.props.children;
        return <div />;
    }
}

function mapStateToProps(state, ownProps) {
    //debugger;
    var oProps = {
        isLoggedIn: state.domain.li,
        token: state.domain.t,
        expires_in: state.sso.userDetails ? state.sso.userDetails.expires_in : null,
        expiresDate: state.sso.userDetails ? state.sso.userDetails.expiresDate : null,
        dateLoaded: state.sso.userDetails ? state.sso.userDetails.dateLoaded : null,
        refresh_token: state.domain.rt,
        currentURL: ownProps.location ? ownProps.location.pathname : null, 
        redirectURL: state.domain.ru ? state.domain.ru : "/",
        isMobile: state.domain.mq
    };

    return oProps;
}

const mapDispatchToProps = (dispatch) => {
    return {
        refreshToken: function (sRefreshToken) {
            return dispatch({
                type: types.USER_AUTHENTICATE_REFRESH,
                refresh_token: sRefreshToken
            });
        },
        logout: function (sLogoutMessage) {
            //debugger;
            return dispatch({
                type: types.LOGOUT, logoutMessage: sLogoutMessage 
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnsureLoggedIn);